import React from 'react';

export const ARROW_DROPDOWN = {
  id: 'ARROW_DROPDOWN',
  viewBox: '0 0 9 5',
  data: (
    <svg width="9" height="5" xmlns="http://www.w3.org/2000/svg">
      <path d="M.25.75L4.625 4.5 9 .75z" fill="currentColor" fillRule="evenodd" />
    </svg>
  ),
};
export const ADD_GLYPH = {
  id: 'ADD_GLYPH',
  viewBox: '0 0 30 30',
  data: (
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M-5-5h40v40H-5z" />
        <path
          d="M29.837 15.012a1.66 1.66 0 0 0-1.661-1.662l-11.514-.012V1.812A1.66 1.66 0 0 0 15 .151a1.66 1.66 0 0 0-1.662 1.661v11.526H1.812A1.66 1.66 0 0 0 .151 15c0 .92.742 1.662 1.661 1.662h11.526v11.526c0 .919.743 1.661 1.662 1.661a1.66 1.66 0 0 0 1.662-1.661V16.662h11.526a1.67 1.67 0 0 0 1.65-1.65z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
};
export const ARROW_RIGHT = {
  id: 'ARROW_RIGHT',
  viewBox: '0 0 24 24',
  data: (
    <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z" fill="currentColor" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  ),
};
export const BUTTON_HINT = {
  id: 'BUTTON_HINT',
  viewBox: '0 0 14 14',
  data: (
    <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.759 8.5c0 .276-.216.5-.5.5H6.5a.505.505 0 01-.5-.5V8C6 7.349 8.25 6.06 8.25 5c0-.348-.225-1.25-1.25-1.25-1.021 0-1.212.984-1.245 1.25 0 0-1.486.022-1.485 0-.001-.934.734-2.75 2.73-2.75 1.721 0 2.75 1.398 2.75 2.75 0 1.373-1.991 2.61-1.991 3v.5zM7 12a1 1 0 110-2 1 1 0 010 2zM0 7a7 7 0 1014 0A7 7 0 000 7z"
        fill="currentColor"
      />
    </svg>
  ),
};
export const CHECK = {
  id: 'CHECK',
  viewBox: '0 0 15 11',
  data: (
    <svg width="15" height="11" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 8.475L1.608 5.583A.83.83 0 1 0 .433 6.758l3.484 3.484a.83.83 0 0 0 1.175 0l8.816-8.817A.83.83 0 1 0 12.733.25L4.5 8.475z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
};
export const DOWNLOAD = {
  id: 'DOWNLOAD',
  viewBox: '0 0 16 16',
  data: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M8,0 C12.418,0 16,3.582 16,8 C16,12.418 12.418,16 8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,0 8,0 Z M8,2 C4.692,2 2,4.692 2,8 C2,11.308 4.692,14 8,14 C11.308,14 14,11.308 14,8 C14,4.692 11.308,2 8,2 Z M11,9.5 C8.99394614,12 8.33753424,12.642482 8.33753424,12.642482 C8.15366364,12.8401935 7.84881952,12.8399338 7.66177128,12.642482 C7.66177128,12.642482 7,12 5,9.5 C4.53501573,8.91876966 4.5,8.5 5.5,8.5 L6.5,8.5 L6.5,5 C6.49999999,4.44390917 7.00090414,3.5 8.00045207,3.5 C9,3.5 9.49999996,4.44782158 9.5,5 L9.5,8.5 L10.5,8.5 C11.5,8.5 11.4674389,8.91746463 11,9.5 Z"
      />
    </svg>
  ),
};
export const DROPZONE_IMAGE = {
  id: 'DROPZONE_IMAGE',
  viewBox: '0 0 113 155',
  data: (
    <svg
      width="113"
      height="155"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <rect id="dropzone-a" x="0" y="0" width="113" height="155" rx="8" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="dropzone-b" fill="#fff">
          <use xlinkHref="#dropzone-a" />
        </mask>
        <use fill="#FFF" xlinkHref="#dropzone-a" />
        <path fillOpacity=".151" fill="currentColor" mask="url(#dropzone-b)" d="M0 0h113v155H0z" />
        <rect
          fillOpacity=".4"
          fill="currentColor"
          mask="url(#dropzone-a)"
          transform="rotate(40 26.5 210.5)"
          x="-47"
          y="137"
          width="147"
          height="147"
          rx="8"
        />
        <rect
          fillOpacity=".9"
          fill="currentColor"
          mask="url(#dropzone-a)"
          transform="rotate(42 75.5 184)"
          x="2"
          y="113"
          width="147"
          height="142"
          rx="8"
        />
        <circle
          fillOpacity=".9"
          fill="currentColor"
          mask="url(#dropzone-b)"
          cx="35"
          cy="48"
          r="13"
        />
      </g>
    </svg>
  ),
};
export const FIELD_TEXT = {
  id: 'FIELD_TEXT',
  viewBox: '-5 -5 20 20',
  data: (
    <path
      d="M8.507 10.833a.803.803 0 0 0 .75-1.1L5.715.725a1.136 1.136 0 0 0-2.117 0L.057 9.733a.807.807 0 1 0 1.508.575l.733-1.975h4.7l.75 1.984a.824.824 0 0 0 .759.516zM2.932 6.667l1.725-4.6 1.725 4.6h-3.45z"
      fill="currentColor"
      fillRule="nonzero"
    />
  ),
};
export const FIELD_PHONE = {
  id: 'FIELD_PHONE',
  viewBox: '-2 -2 20 20',
  data: (
    <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.2223,2.8573 C6.4953,3.1303 6.4953,3.5723 6.2223,3.8453 L5.2333,4.8333 C4.9603,5.1063 5.0863,5.4653 5.2333,5.8213 C5.5833,6.6653 6.3453,7.5103 7.4163,8.5813 C8.6103,9.7763 9.3313,10.3323 10.1753,10.7653 C10.5193,10.9413 10.8913,11.0383 11.1633,10.7653 L12.1523,9.7783 C12.4253,9.5053 12.8673,9.5053 13.1403,9.7783 L15.1173,11.7563 C15.3903,12.0293 15.3903,12.4713 15.1173,12.7443 L13.0653,14.7953 C12.8233,15.0373 12.4423,15.0683 12.1643,14.8693 C12.1643,14.8693 8.1363,13.6693 5.2333,10.7653 C2.2063,7.7373 1.1303,3.8303 1.1303,3.8303 C0.9313,3.5523 0.9633,3.1713 1.2043,2.9303 L3.2573,0.8793 C3.5303,0.6063 3.9723,0.6063 4.2453,0.8793 L6.2223,2.8573 Z"
        fill="currentColor"
      />
    </svg>
  ),
};
export const FIELD_EMAIL = {
  id: 'FIELD_EMAIL',
  viewBox: '-2 -2 20 20',
  data: (
    <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1,11.5004529 L1,8.28698353 C1,7.74071872 1.39692412,7.50310534 1.88655484,7.76240678 L7.11344516,10.5304932 C7.60359323,10.7900686 8.39692412,10.7897947 8.88655484,10.5304932 L14.1134452,7.76240678 C14.6035932,7.50283136 15,7.73797416 15,8.28700095 L15,11.5005267 C15,12.3229093 14.3292128,12.9999952 13.5017548,12.9999893 L2.49824524,12.9999107 C1.6752491,12.9999048 1,12.3285747 1,11.5004529 Z M1,5.5 L1,4.49755925 C1,3.66995412 1.67078724,3 2.49824524,3 L13.5017548,3 C14.3247509,3 15,3.67048011 15,4.49755925 L15,5.5 L8.88655484,8.55672258 C8.39640677,8.80179662 7.60307588,8.80153794 7.11344516,8.55672258 L1,5.5 Z"
        fill="currentColor"
      />
    </svg>
  ),
};
export const FIELD_CURRENCY = {
  id: 'FIELD_CURRENCY',
  viewBox: '-2 -2 20 20',
  data: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M12.389 2.079a1 1 0 0 1 .446.404A.967.967 0 0 1 13 3v1c0 .55-.45 1-1 1s-.95-1-1.5-1a.504.504 0 0 1-.5-.504v-.99c0-.291.226-.505.505-.505H12c.137 0 .268.029.389.079zM10 8.707V7.642c0-.28.204-.412.456-.303 0 0 2.544.87 2.544 3.217 0 2.359-2.531 3.145-2.531 3.145-.253.11-.469-.038-.469-.32v-1c0-.293.182-.634.407-.789 0 0 .593-.245.593-1.036 0-.761-.593-1.046-.593-1.046-.214-.172-.407-.526-.407-.802zM8 1c.556 0 1 .444 1 .99V14c0 .547-.448 1-1 1-.556 0-1-.448-1-1H4a.997.997 0 0 1-.706-.294A.993.993 0 0 1 3 13v-1c0-.55.45-1 1-1s1 1 2 1h1V9s-.427-.005-1-.128C4.815 8.617 3 7.845 3 5.5c0-2.36 1.815-3.126 3-3.377C6.573 2.003 7 2 7 2v-.003C7 1.453 7.448 1 8 1zM5 5.5c0 .76.5 1.135 1 1.32.5.185.999.18 1 .18V4c-.001 0-.5-.02-1 .156-.5.177-1 .552-1 1.344z"
      />
    </svg>
  ),
};
export const FIELD_COLLABORATOR = {
  id: 'FIELD_COLLABORATOR',
  viewBox: '-2 -2 20 20',
  data: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M10.9829643,12.6437806 C12.5286237,12.8078951 14.5,12.5099682 14.5,11.75 C14.5,10.5 13.8333333,8.66666667 11.8333333,8.66666667 C11.1832271,8.66666667 10.6740002,8.86037582 10.2827561,9.1647938 C10.7576427,9.97237834 11,11.0340775 11,12.375 C11,12.4666129 10.9943133,12.5562282 10.9829643,12.6437806 Z M5.5,7 C4.11928813,7 3,5.88071187 3,4.5 C3,3.11928813 4.11928813,2 5.5,2 C6.88071187,2 8,3.11928813 8,4.5 C8,5.88071187 6.88071187,7 5.5,7 Z M11.8333333,8 C10.7287638,8 9.83333333,7.1045695 9.83333333,6 C9.83333333,4.8954305 10.7287638,4 11.8333333,4 C12.9379028,4 13.8333333,4.8954305 13.8333333,6 C13.8333333,7.1045695 12.9379028,8 11.8333333,8 Z M5.5,8 C8.16666667,8 10,9 10,12.5 C10,13.4454885 9,14.5 5.5,14.5 C2,14.5 1,13.5545115 1,12.5 C1,9 2.83333333,8 5.5,8 Z"
      />
    </svg>
  ),
};
export const FIELD_ATTACHMENT = {
  id: 'FIELD_ATTACHMENT',
  viewBox: '-3 -1 20 20',
  data: (
    <svg width="14" height="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 .667c-.917 0-1.658.75-1.658 1.666L.333 15.667c0 .916.742 1.666 1.659 1.666H12c.917 0 1.667-.75 1.667-1.666V6.358c0-.441-.175-.866-.492-1.175L9.15 1.158A1.638 1.638 0 0 0 7.975.667H2zm5.833 5v-3.75L12.417 6.5h-3.75a.836.836 0 0 1-.834-.833z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_RECORD_REF = {
  id: 'FIELD_RECORD_REF',
  viewBox: '-2.5 -3.5 20 20',
  data: (
    <svg width="15" height="13" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.167 1.833h11.666A.836.836 0 0 0 13.667 1a.836.836 0 0 0-.834-.833H1.167A.836.836 0 0 0 .333 1c0 .458.375.833.834.833zm9.858 3.334H1.167A.836.836 0 0 0 .333 6c0 .458.375.833.834.833h10.108c.833 0 1.608.559 1.742 1.384a1.67 1.67 0 0 1-1.642 1.95H9.5v-.659a.412.412 0 0 0-.708-.291L7.3 10.708a.413.413 0 0 0 0 .592l1.492 1.492A.413.413 0 0 0 9.5 12.5v-.667h1.667a3.332 3.332 0 0 0 3.316-3.658c-.166-1.733-1.716-3.008-3.458-3.008zm-6.525 5H1.167A.836.836 0 0 0 .333 11c0 .458.375.833.834.833H4.5A.836.836 0 0 0 5.333 11a.836.836 0 0 0-.833-.833z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_LONG_TEXT = {
  id: 'FIELD_LONG_TEXT',
  viewBox: '-2 -2 20 20',
  data: (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.667 10.5H1.333a.836.836 0 0 0-.833.833c0 .459.375.834.833.834h8.334a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833zm0-6.667H1.333a.836.836 0 0 0-.833.834c0 .458.375.833.833.833h8.334a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834zm-8.334 5h13.334A.836.836 0 0 0 15.5 8a.836.836 0 0 0-.833-.833H1.333A.836.836 0 0 0 .5 8c0 .458.375.833.833.833zm0 6.667h13.334a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834H1.333a.836.836 0 0 0-.833.834c0 .458.375.833.833.833zM.5 1.333c0 .459.375.834.833.834h13.334a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833H1.333a.836.836 0 0 0-.833.833z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_DATE = {
  id: 'FIELD_DATE',
  viewBox: '-2 -1 20 20',
  data: (
    <svg width="16" height="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.833 2.333H13V1.5a.836.836 0 0 0-.833-.833.836.836 0 0 0-.834.833v.833H4.667V1.5a.836.836 0 0 0-.834-.833A.836.836 0 0 0 3 1.5v.833h-.833A1.66 1.66 0 0 0 .508 4L.5 15.667c0 .916.742 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666V4c0-.917-.75-1.667-1.667-1.667zm0 12.5a.836.836 0 0 1-.833.834H3a.836.836 0 0 1-.833-.834V6.5h11.666v8.333zm-10-6.666H5.5v1.666H3.833V8.167zm3.334 0h1.666v1.666H7.167V8.167zm3.333 0h1.667v1.666H10.5V8.167z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_NUMBER = {
  id: 'FIELD_NUMBER',
  viewBox: '-2.5 -3.5 20 20',
  data: (
    <svg width="15" height="13" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 1.82V3.5l3-1v9.6h2V.1h-.25L0 1.82zm13.82-.67c-.34-.4-.75-.7-1.23-.88C12.12.09 11.58 0 11 0c-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39V5.13c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51h-.01z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_LOOKUP = {
  id: 'FIELD_LOOKUP',
  viewBox: '-3 -1 20 20',
  data: (
    <svg width="14" height="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.667 15.325V6.358c0-.441-.175-.866-.492-1.175L9.15 1.158A1.638 1.638 0 0 0 7.975.667H2c-.917 0-1.658.75-1.658 1.666L.333 15.667c0 .916.742 1.666 1.659 1.666H12c.375 0 .708-.125.992-.333L9.3 13.308a4.149 4.149 0 0 1-2.5.684C4.825 13.9 3.133 12.358 2.867 10.4a4.177 4.177 0 0 1 4.858-4.675C9.35 6 10.7 7.267 11.058 8.875a4.164 4.164 0 0 1-.583 3.25l3.192 3.2zM4.5 9.833c0 1.384 1.117 2.5 2.5 2.5s2.5-1.116 2.5-2.5c0-1.383-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_SELECT = {
  id: 'FIELD_SELECT',
  viewBox: '-1.5 -1.5 20 20',
  data: (
    <svg width="17" height="17" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 8.335C17 3.735 13.266 0 8.665 0A8.338 8.338 0 0 0 .33 8.335c0 4.6 3.734 8.335 8.335 8.335 4.6 0 8.335-3.734 8.335-8.335zM5.748 6.668h5.834c.342 0 .542.392.334.667l-2.918 3.892a.414.414 0 0 1-.666 0L5.414 7.335a.417.417 0 0 1 .334-.667z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_RATING = {
  id: 'FIELD_RATING',
  viewBox: '0 0 16 16',
  data: (
    <svg width="16" height="14" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0-1h16v16H0z" />
        <path
          d="M14.375 4.533l-4.033-.35L8.767.475C8.483-.2 7.517-.2 7.233.475L5.658 4.192l-4.025.341C.9 4.592.6 5.508 1.158 5.992l3.059 2.65-.917 3.933a.831.831 0 0 0 1.242.9L8 11.392l3.458 2.091a.831.831 0 0 0 1.242-.9l-.917-3.941 3.059-2.65c.558-.484.266-1.4-.467-1.459zM8 9.833l-3.133 1.892.833-3.567-2.767-2.4 3.65-.316L8 2.083 9.425 5.45l3.65.317-2.767 2.4.834 3.566L8 9.833z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
};
export const FIELD_MULTI_SELECT = {
  id: 'FIELD_MULTI_SELECT',
  viewBox: '-2 -5 20 20',
  data: (
    <svg width="16" height="10" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.333 2.5A.836.836 0 0 1 .5 1.667c0-.459.375-.834.833-.834h10c.459 0 .834.375.834.834a.836.836 0 0 1-.834.833h-10zm0 3.333A.836.836 0 0 1 .5 5c0-.458.375-.833.833-.833h10c.459 0 .834.375.834.833a.836.836 0 0 1-.834.833h-10zm0 3.334A.836.836 0 0 1 .5 8.333c0-.458.375-.833.833-.833h10c.459 0 .834.375.834.833a.836.836 0 0 1-.834.834h-10zM13 1.042h2.292l-1.146 1.25L13 1.042zm0 3.333h2.292l-1.146 1.25L13 4.375zm0 3.333h2.292l-1.146 1.25L13 7.708z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_CHECKBOX = {
  id: 'FIELD_CHECKBOX',
  viewBox: '-1 -1 20 20',
  data: (
    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 .667A8.336 8.336 0 0 0 .667 9c0 4.6 3.733 8.333 8.333 8.333S17.333 13.6 17.333 9 13.6.667 9 .667zM6.742 12.575L3.75 9.583a.83.83 0 1 1 1.175-1.175l2.408 2.4 5.734-5.733a.83.83 0 1 1 1.175 1.175l-6.325 6.325a.83.83 0 0 1-1.175 0z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
export const FIELD_FORMULA = {
  id: 'FIELD_FORMULA',
  viewBox: '-2 -2 20 20',
  data: (
    <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        className=""
        d="M13.427,12.2326 L14.489,13.2946 C14.877,13.6826 14.877,14.3196 14.488,14.7086 C14.1,15.0976 13.463,15.0976 13.074,14.7086 L12.013,13.6476 L10.953,14.7086 C10.564,15.0976 9.928,15.0976 9.539,14.7086 L9.538,14.7076 C9.149,14.3196 9.149,13.6836 9.538,13.2946 L10.599,12.2326 L9.539,11.1726 C9.15,10.7836 9.15,10.1476 9.539,9.7586 C9.928,9.3696 10.564,9.3696 10.953,9.7586 L12.012,10.8176 L13.073,9.7556 C13.463,9.3656 14.099,9.3656 14.488,9.7546 L14.489,9.7556 C14.877,10.1446 14.877,10.7806 14.489,11.1696 L13.427,12.2326 Z M10.2468,0.0002 C12.87146,0.0002 13.3978592,2.53145 13.3978592,2.53145 C13.4839914,2.7844474 13.3156952,3.0002 13.0341343,3.0002 L11.756611,3.0002 C11.4754573,3.0002 11.1584611,2.7973017 11.0494895,2.54701396 C11.0494895,2.54701396 10.977478,2.0002 10.2468,2.0002 C9.4658,2.0002 9.2468,3.0002 9.2468,3.0002 L8.8468,5.0002 L9.2468,5.0002 L10.7468,5.0002 C11.0218,5.0002 11.2468,5.2252 11.2468,5.5002 C11.2468,5.7752 11.0218,6.0002 10.7468,6.0002 L9.2468,6.0002 L8.6468,6.0002 L7.2468,13.0002 C6.9348,14.3752 5.4968,16.0002 3.2468,16.0002 C1.2138,16.0002 0.5268,14.1722 0.3238,13.3702 C0.2748,13.1802 0.4208,13.0002 0.6168,13.0002 L1.74888936,13.0002 C2.02015548,13.0002 2.34410227,13.1978777 2.46413071,13.4417255 C2.46413071,13.4417255 2.59429932,14.0002 3.2468,14.0002 C4.0288,14.0002 4.2468,13.0002 4.2468,13.0002 L5.6468,6.0002 L5.2468,6.0002 L4.7468,6.0002 C4.4718,6.0002 4.2468,5.7752 4.2468,5.5002 C4.2468,5.2252 4.4718,5.0002 4.7468,5.0002 L5.2468,5.0002 L5.8468,5.0002 L6.2468,3.0002 C6.5598,1.6252 7.62214004,0.0002 10.2468,0.0002 Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
};
export const FIELD_ROLLUP = {
  id: 'FIELD_ROLLUP',
  viewBox: '-2 -2 20 20',
  data: (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="nonzero"
        fill="currentColor"
        d="M9.6.727C9.6.326 9.242 0 8.8 0 3.94 0 0 3.582 0 8s3.94 8 8.8 8h.4c3.756 0 6.8-2.768 6.8-6.182 0-3.414-3.044-6.182-6.8-6.182h-.4C6.149 3.636 4 5.59 4 8s2.149 4.364 4.8 4.364h.4c1.546 0 2.8-1.14 2.8-2.546s-1.254-2.545-2.8-2.545h-.4c-.442 0-.8.325-.8.727 0 .402.358.727.8.727h.4c.663 0 1.2.489 1.2 1.091 0 .603-.537 1.091-1.2 1.091h-.4C7.033 10.91 5.6 9.607 5.6 8c0-1.607 1.433-2.91 3.2-2.91h.4c2.872 0 5.2 2.117 5.2 4.728 0 2.611-2.328 4.727-5.2 4.727h-.4c-3.976 0-7.2-2.93-7.2-6.545 0-3.615 3.224-6.545 7.2-6.545.442 0 .8-.326.8-.728z"
      />
    </svg>
  ),
};
export const FILE_VIDEO = {
  id: 'FILE_VIDEO',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#DB4564" d="M0 0h48v48H0z" />
        <path
          d="M31.2 14H36v16.625C36 31.931 34.92 33 33.6 33H14.4c-1.32 0-2.4-1.069-2.4-2.375v-14.25C12 15.069 13.08 14 14.4 14h1.2l2.4 4.75h3.6L19.2 14h2.4l2.4 4.75h3.6L25.2 14h2.4l2.4 4.75h3.6L31.2 14zm-9.6 8.313v7.125l5.657-3.563-5.657-3.563z"
          fill="#FFF"
        />
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#DB4564" d="M0 0h48v48H0z" />
        <path
          d="M31.2 14H36v16.625C36 31.931 34.92 33 33.6 33H14.4c-1.32 0-2.4-1.069-2.4-2.375v-14.25C12 15.069 13.08 14 14.4 14h1.2l2.4 4.75h3.6L19.2 14h2.4l2.4 4.75h3.6L25.2 14h2.4l2.4 4.75h3.6L31.2 14zm-9.6 8.313v7.125l5.657-3.563-5.657-3.563z"
          fill="#FFF"
        />
      </g>
    </svg>`,
};
export const FILE_HTML = {
  id: 'FILE_HTML',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#708A9F" d="M0 0h48v48H0z" />
        <path
          d="M16.5 12a2.507 2.507 0 0 0-2.5 2.5v20c0 1.375 1.125 2.5 2.5 2.5h15c1.375 0 2.5-1.125 2.5-2.5v-15L26.5 12h-10z"
          fill="#FFF"
        />
        <text fontFamily="Helvetica" fontSize="10" fill="#708A9F" transform="translate(14 12)">
          <tspan x="3" y="17">
            &lt;/&gt;
          </tspan>
        </text>
      </g>
    </svg>
  ),
  dataString: ` <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#708A9F" d="M0 0h48v48H0z" />
        <path
          d="M16.5 12a2.507 2.507 0 0 0-2.5 2.5v20c0 1.375 1.125 2.5 2.5 2.5h15c1.375 0 2.5-1.125 2.5-2.5v-15L26.5 12h-10z"
          fill="#FFF"
        />
        <text fontFamily="Helvetica" fontSize="10" fill="#708A9F" transform="translate(14 12)">
          <tspan x="3" y="17">
            &lt;/&gt;
          </tspan>
        </text>
      </g>
    </svg>`,
};
export const FILE_TEXT = {
  id: 'FILE_TEXT',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M2.5 0h10L20 7.5v15c0 1.375-1.125 2.5-2.5 2.5h-15A2.507 2.507 0 0 1 0 22.5v-20C0 1.125 1.125 0 2.5 0zm.441 17.857h14.706v-1.19H2.353v1.19h.588zm0 3.572h14.706v-1.19H2.353v1.19h.588z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#B1BAC1" d="M0 0h48v48H0z" />
        <use fill="#FFF" href="#a" transform="translate(14 11)" />
        <text
          fontFamily="TimesNewRomanPSMT, Times New Roman"
          fontSize="16.8"
          fill="#B1BAC1"
          transform="translate(14 11)"
        >
          <tspan x="3.529" y="15">
            T
          </tspan>
        </text>
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M2.5 0h10L20 7.5v15c0 1.375-1.125 2.5-2.5 2.5h-15A2.507 2.507 0 0 1 0 22.5v-20C0 1.125 1.125 0 2.5 0zm.441 17.857h14.706v-1.19H2.353v1.19h.588zm0 3.572h14.706v-1.19H2.353v1.19h.588z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#B1BAC1" d="M0 0h48v48H0z" />
        <use fill="#FFF" href="#a" transform="translate(14 11)" />
        <text
          fontFamily="TimesNewRomanPSMT, Times New Roman"
          fontSize="16.8"
          fill="#B1BAC1"
          transform="translate(14 11)"
        >
          <tspan x="3.529" y="15">
            T
          </tspan>
        </text>
      </g>
    </svg>`,
};
export const FILE_ZIP = {
  id: 'FILE_ZIP',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M.68 29V.746L8 1v1h1v1H8v1h1v1H8v1h1v1H8v1h1v1H8v1h1v1H8v1h1v1H8v1h.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H10v-1h1v-1h-1v-1h1v-1h-1V9h1V8h-1V7h1V6h-1V5h1V4h-1V3h1V2h-1V1h8.46c0 .552-.552 1 0 1v27H.68z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#FFB526" d="M0 0h48v48H0z" />
        <g transform="translate(14 9)">
          <mask id="b" fill="#fff">
            <use href="#a" />
          </mask>
          <path
            d="M-1 5.5v20C-1 26.875.125 28 1.5 28h15c1.375 0 2.5-1.125 2.5-2.5v-15L11.5 3h-10A2.507 2.507 0 0 0-1 5.5z"
            fill="#FFF"
            mask="url(#b)"
          />
        </g>
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M.68 29V.746L8 1v1h1v1H8v1h1v1H8v1h1v1H8v1h1v1H8v1h1v1H8v1h1v1H8v1h.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H10v-1h1v-1h-1v-1h1v-1h-1V9h1V8h-1V7h1V6h-1V5h1V4h-1V3h1V2h-1V1h8.46c0 .552-.552 1 0 1v27H.68z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#FFB526" d="M0 0h48v48H0z" />
        <g transform="translate(14 9)">
          <mask id="b" fill="#fff">
            <use href="#a" />
          </mask>
          <path
            d="M-1 5.5v20C-1 26.875.125 28 1.5 28h15c1.375 0 2.5-1.125 2.5-2.5v-15L11.5 3h-10A2.507 2.507 0 0 0-1 5.5z"
            fill="#FFF"
            mask="url(#b)"
          />
        </g>
      </g>
    </svg>`,
};

export const FILE_CODE = {
  id: 'FILE_CODE',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#708A9F" d="M0 0h48v48H0z" />
        <path
          d="M16.5 11h10l7.5 7.5v15c0 1.375-1.125 2.5-2.5 2.5h-15a2.507 2.507 0 0 1-2.5-2.5v-20c0-1.375 1.125-2.5 2.5-2.5zm5.836 18.794l.219-.668c-.79-.256-1.19-.917-1.2-1.982v-1.198c0-.887-.32-1.505-.96-1.854.64-.345.96-.957.96-1.837V21.08c0-1.093.4-1.77 1.2-2.029l-.219-.668c-.685.197-1.195.514-1.53.95-.336.436-.507 1.008-.515 1.718v1.209c0 .938-.406 1.406-1.217 1.406v.843c.811 0 1.217.471 1.217 1.413v1.157c0 .728.172 1.314.514 1.758.343.444.854.762 1.531.956zm3.372-.668l.224.668c.67-.194 1.179-.51 1.526-.947.346-.438.52-1.021.52-1.75v-1.174c0-.942.405-1.413 1.217-1.413v-.843c-.812 0-1.218-.463-1.218-1.389v-1.22c-.003-.717-.176-1.294-.517-1.73-.34-.436-.85-.75-1.528-.944l-.218.668c.8.26 1.2.936 1.2 2.029v1.18c0 .903.347 1.513 1.04 1.83-.693.326-1.04.937-1.04 1.832v1.279c-.026 1.03-.428 1.672-1.206 1.924z"
          fill="#FFF"
        />
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#708A9F" d="M0 0h48v48H0z" />
        <path
          d="M16.5 11h10l7.5 7.5v15c0 1.375-1.125 2.5-2.5 2.5h-15a2.507 2.507 0 0 1-2.5-2.5v-20c0-1.375 1.125-2.5 2.5-2.5zm5.836 18.794l.219-.668c-.79-.256-1.19-.917-1.2-1.982v-1.198c0-.887-.32-1.505-.96-1.854.64-.345.96-.957.96-1.837V21.08c0-1.093.4-1.77 1.2-2.029l-.219-.668c-.685.197-1.195.514-1.53.95-.336.436-.507 1.008-.515 1.718v1.209c0 .938-.406 1.406-1.217 1.406v.843c.811 0 1.217.471 1.217 1.413v1.157c0 .728.172 1.314.514 1.758.343.444.854.762 1.531.956zm3.372-.668l.224.668c.67-.194 1.179-.51 1.526-.947.346-.438.52-1.021.52-1.75v-1.174c0-.942.405-1.413 1.217-1.413v-.843c-.812 0-1.218-.463-1.218-1.389v-1.22c-.003-.717-.176-1.294-.517-1.73-.34-.436-.85-.75-1.528-.944l-.218.668c.8.26 1.2.936 1.2 2.029v1.18c0 .903.347 1.513 1.04 1.83-.693.326-1.04.937-1.04 1.832v1.279c-.026 1.03-.428 1.672-1.206 1.924z"
          fill="#FFF"
        />
      </g>
    </svg>`,
};
export const FILE_PPT = {
  id: 'FILE_PPT',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#E24325" d="M0 0h48v48H0z" />
        <g transform="translate(10 10)">
          <path
            d="M16.876 20.008v-1.986h6.446v-1.324h-6.446V5.934h9.446v16.941h-9.446v-1.542h6.446v-1.325h-6.446z"
            fill="#FFF"
          />
          <circle fill="#E24325" cx="18.5" cy="11.5" r="2.5" />
          <path stroke="#FFF" fill="#D8D8D8" d="M17.5 4.5h10v1h-10zM27.5 5.5h1v13h-1z" />
          <path fill="#FFF" d="M16.194.934v26.5L.322 24.624V3.632zM22.243 11.621h-3.698V7.71z" />
          <path
            d="M20.355 9.234c.23.181.6.615.737 1.015.175.514.152 1.088.152 1.088h-2.45V8.682s.983.095 1.561.552z"
            fill="#E24325"
          />
          <text fontFamily=".SFNSText, .SF NS Text" fontSize="12.313" fill="#E24325">
            <tspan x="4.347" y="17.116">
              P
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#E24325" d="M0 0h48v48H0z" />
        <g transform="translate(10 10)">
          <path
            d="M16.876 20.008v-1.986h6.446v-1.324h-6.446V5.934h9.446v16.941h-9.446v-1.542h6.446v-1.325h-6.446z"
            fill="#FFF"
          />
          <circle fill="#E24325" cx="18.5" cy="11.5" r="2.5" />
          <path stroke="#FFF" fill="#D8D8D8" d="M17.5 4.5h10v1h-10zM27.5 5.5h1v13h-1z" />
          <path fill="#FFF" d="M16.194.934v26.5L.322 24.624V3.632zM22.243 11.621h-3.698V7.71z" />
          <path
            d="M20.355 9.234c.23.181.6.615.737 1.015.175.514.152 1.088.152 1.088h-2.45V8.682s.983.095 1.561.552z"
            fill="#E24325"
          />
          <text fontFamily=".SFNSText, .SF NS Text" fontSize="12.313" fill="#E24325">
            <tspan x="4.347" y="17.116">
              P
            </tspan>
          </text>
        </g>
      </g>
    </svg>`,
};
export const FILE_EXCEL = {
  id: 'FILE_EXCEL',
  viewBox: '0 0.5 48 48',
  data: (
    <svg width="48" height="49" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#02955F" d="M0 .604h48v48H0z" />
        <path
          d="M26.27 33.047h3.902v-2.764H26.27v-.83h3.902V26.69H26.27v-.829h3.902v-2.764H26.27v-.829h3.902v-2.764H26.27v-.829h3.902v-2.763H26.27V14.47h10.764v20.59H26.27v-2.013zm-.671-21.696v26.767L9.989 35.28V14.075l15.61-2.724zm5.38 4.56v2.764h4.44v-2.763h-4.44zm0 3.593v2.764h4.44v-2.764h-4.44zm0 3.593v2.764h4.44v-2.764h-4.44zm0 3.593v2.764h4.44V26.69h-4.44zm0 3.593v2.764h4.44v-2.764h-4.44z"
          fill="#FFF"
        />
        <text
          fontFamily=".SFNSText, .SF NS Text"
          fontSize="12.061"
          fill="#02955F"
          transform="translate(9.989 11.351)"
        >
          <tspan x="3.803" y="16.602">
            X
          </tspan>
        </text>
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="49" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#02955F" d="M0 .604h48v48H0z" />
        <path
          d="M26.27 33.047h3.902v-2.764H26.27v-.83h3.902V26.69H26.27v-.829h3.902v-2.764H26.27v-.829h3.902v-2.764H26.27v-.829h3.902v-2.763H26.27V14.47h10.764v20.59H26.27v-2.013zm-.671-21.696v26.767L9.989 35.28V14.075l15.61-2.724zm5.38 4.56v2.764h4.44v-2.763h-4.44zm0 3.593v2.764h4.44v-2.764h-4.44zm0 3.593v2.764h4.44v-2.764h-4.44zm0 3.593v2.764h4.44V26.69h-4.44zm0 3.593v2.764h4.44v-2.764h-4.44z"
          fill="#FFF"
        />
        <text
          fontFamily=".SFNSText, .SF NS Text"
          fontSize="12.061"
          fill="#02955F"
          transform="translate(9.989 11.351)"
        >
          <tspan x="3.803" y="16.602">
            X
          </tspan>
        </text>
      </g>
    </svg>`,
};
export const FILE_PDF = {
  id: 'FILE_PDF',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#DB5565" d="M0 0h48v48H0z" />
        <path
          d="M23.7 11.354c.568.247.441.621.253 2.38-.193 1.821-.834 5.139-2.072 8.396-1.24 3.261-3.08 6.462-4.682 8.834-1.6 2.37-2.972 3.911-4.016 4.8-1.05.888-1.775 1.124-2.249 1.206-.47.08-.683 0-.81-.237-.127-.236-.171-.634-.062-1.106.107-.476.362-1.03 1.086-1.738.73-.711 1.925-1.58 3.593-2.393 1.668-.809 3.803-1.56 5.557-2.072 1.754-.515 3.12-.79 4.317-1.007 1.2-.217 2.224-.375 3.228-.453a17.953 17.953 0 0 1 2.952 0c.961.078 1.902.236 2.715.43.812.199 1.496.437 2.095.813.597.375 1.111.889 1.366 1.462.26.573.26 1.205.045 1.66-.214.453-.643.731-1.133.886-.49.158-1.047.198-1.71 0-.663-.197-1.435-.63-2.245-1.205-.81-.572-1.667-1.28-2.778-2.388a48.753 48.753 0 0 1-3.634-4.071c-1.153-1.463-2.097-2.885-2.739-4.09a15.241 15.241 0 0 1-1.26-3.182c-.278-.987-.491-1.975-.576-2.863a10.05 10.05 0 0 1 .042-2.31c.085-.634.216-1.107.428-1.423.213-.317.514-.475.728-.553.213-.081.343-.081.47-.099.126-.019.253-.06.45 0 .186.054.434.205.64.323h0z"
          stroke="#FFF"
          strokeWidth="1.57"
        />
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#DB5565" d="M0 0h48v48H0z" />
        <path
          d="M23.7 11.354c.568.247.441.621.253 2.38-.193 1.821-.834 5.139-2.072 8.396-1.24 3.261-3.08 6.462-4.682 8.834-1.6 2.37-2.972 3.911-4.016 4.8-1.05.888-1.775 1.124-2.249 1.206-.47.08-.683 0-.81-.237-.127-.236-.171-.634-.062-1.106.107-.476.362-1.03 1.086-1.738.73-.711 1.925-1.58 3.593-2.393 1.668-.809 3.803-1.56 5.557-2.072 1.754-.515 3.12-.79 4.317-1.007 1.2-.217 2.224-.375 3.228-.453a17.953 17.953 0 0 1 2.952 0c.961.078 1.902.236 2.715.43.812.199 1.496.437 2.095.813.597.375 1.111.889 1.366 1.462.26.573.26 1.205.045 1.66-.214.453-.643.731-1.133.886-.49.158-1.047.198-1.71 0-.663-.197-1.435-.63-2.245-1.205-.81-.572-1.667-1.28-2.778-2.388a48.753 48.753 0 0 1-3.634-4.071c-1.153-1.463-2.097-2.885-2.739-4.09a15.241 15.241 0 0 1-1.26-3.182c-.278-.987-.491-1.975-.576-2.863a10.05 10.05 0 0 1 .042-2.31c.085-.634.216-1.107.428-1.423.213-.317.514-.475.728-.553.213-.081.343-.081.47-.099.126-.019.253-.06.45 0 .186.054.434.205.64.323h0z"
          stroke="#FFF"
          strokeWidth="1.57"
        />
      </g>
    </svg>`,
};

export const FILE_WORD = {
  id: 'FILE_WORD',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#306EAD" d="M0 0h48v48H0z" />
        <path
          d="M26.055 30.302V28.66h8.482v-1.095h-8.482v-1.641h8.482v-1.095h-8.482v-1.641h8.482v-1.095h-8.482v-1.642h8.482v-1.094h-8.482v-1.642h8.482v-1.094h-8.482v-2.6H37v20.385H26.055v-3.01h8.482v-1.094h-8.482zm-.682-19.368v26.5l-15.871-2.81V13.632l15.871-2.697z"
          fill="#FFF"
        />
        <text fontFamily=".SFNSText, .SF NS Text" fontSize="12.313" fill="#306EAD">
          <tspan x="11.417" y="27.116">
            W
          </tspan>
        </text>
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#306EAD" d="M0 0h48v48H0z" />
        <path
          d="M26.055 30.302V28.66h8.482v-1.095h-8.482v-1.641h8.482v-1.095h-8.482v-1.641h8.482v-1.095h-8.482v-1.642h8.482v-1.094h-8.482v-1.642h8.482v-1.094h-8.482v-2.6H37v20.385H26.055v-3.01h8.482v-1.094h-8.482zm-.682-19.368v26.5l-15.871-2.81V13.632l15.871-2.697z"
          fill="#FFF"
        />
        <text fontFamily=".SFNSText, .SF NS Text" fontSize="12.313" fill="#306EAD">
          <tspan x="11.417" y="27.116">
            W
          </tspan>
        </text>
      </g>
    </svg>`,
};
export const FILE_DEFAULT = {
  id: 'FILE_DEFAULT',
  viewBox: '0 0 48 48',
  data: (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#708A9F" d="M0 0h48v48H0z" />
        <path
          d="M16.5 12a2.507 2.507 0 0 0-2.5 2.5v20c0 1.375 1.125 2.5 2.5 2.5h15c1.375 0 2.5-1.125 2.5-2.5v-15L26.5 12h-10z"
          fill="#FFF"
        />
      </g>
    </svg>
  ),
  dataString: `<svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path fill="#708A9F" d="M0 0h48v48H0z" />
        <path
          d="M16.5 12a2.507 2.507 0 0 0-2.5 2.5v20c0 1.375 1.125 2.5 2.5 2.5h15c1.375 0 2.5-1.125 2.5-2.5v-15L26.5 12h-10z"
          fill="#FFF"
        />
      </g>
    </svg>`,
};
export const TRASH_CAN = {
  id: 'TRASH_CAN',
  viewBox: '0 0 12 16',
  data: (
    <svg width="12" height="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 13.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V5.5c0-.917-.75-1.667-1.667-1.667H2.667C1.75 3.833 1 4.583 1 5.5v8.333zm10-12.5H8.917L8.325.742A.84.84 0 0 0 7.742.5H4.258a.84.84 0 0 0-.583.242l-.592.591H1a.836.836 0 0 0-.833.834C.167 2.625.542 3 1 3h10a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  ),
};
